import {SpaGlobalConfig} from '../../../generated/core';

export function createBasePath(config: SpaGlobalConfig) {
    // role site: /de/de -> /de
    // role market: /de -> ""
    // author: /content/onehub_pkw/de/de -> /content/onehub_pkw/de

    const appRootPaths = config.appRootPath.split('/');
    return appRootPaths
        .filter((_p, index) => index < appRootPaths.length - 1)
        .join('/');
}
